<div class="rounded-lg font-medium mx-auto max-w-screen-sm text-center p-8">
  <img
    [src]="icon || '/assets/images/no-content.svg'"
    class="h-auto mx-auto h-40"
  />
  <div class="text-center py-4">{{ caption }}</div>
  <ng-content></ng-content>
</div>
